<template>
  <div class="flex w-full items-center">
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="sidebarx sidebar-width"
      spacer
      v-model="assignChatPopup"
    >
      <AssignedChatModal
    /></vs-sidebar>

    <!-- this is for chat input box -->
    <!-- <div class="relative mb-2 mx-2 w-full">
      <b-input
        class="w-full mt-2 bg-f4f5f6 bg-input-cl chat-input-h"
        placeholder="Search here"
        v-model="typedMessage"
        size="large"
      />

      <div class="absolute setinpuicon">
        <feather-icon
          @click="sendMsg"
          icon="SendIcon"
          class="sendicon-set"
          svgClasses="h-6 w-6"
        />
      </div>
    </div> -->

    <!-- this is for assign  -->
    <!-- <div class="bg-white w-full p-4">
      <div class="flex justify-between items-center">
        <p class="mb-0 font-semibold text-lg">
          You are not assigned to this chat
        </p>
        <vs-button
          @click="assignChatPopup = !assignChatPopup"
          color="success"
          class="font-semibold"
          >Assign Chat</vs-button
        >
      </div>
    </div> -->

    <div class="chat__input flex w-full">
      <twemoji-textarea
        ref="emojiTextarea"
        class="flex-1"
        id="chatBoxTextId"
        placeholder="Type a message"
        @update:content="yourMethodToCatchEmojiUnicode"
        @enterKey="sendMsg"
      ></twemoji-textarea>
      <!-- :emojiData="emojiDataAll"
        :emojiGroups="emojiGroups" -->
    </div>
    <div class="cust-sendbuttn-par flex justify-center items-center">
      <div class="bg-primary p-4 rounded-full" @click="sendMsg">
        <a class="">
          <feather-icon
            icon="SendIcon"
            class="text-white flex items-center justify-center"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { TwemojiTextarea } from "@kevinfaguiar/vue-twemoji-picker";
import EmojiAllData from "@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json";
import EmojiDataAnimalsNature from "@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-group-animals-nature.json";
import EmojiDataFoodDrink from "@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-group-food-drink.json";
import EmojiGroups from "@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json";
import AssignedChatModal from "./Messages/AssignedChatModal";
import { mapState } from "vuex";
export default {
  components: {
    "twemoji-textarea": TwemojiTextarea,
    AssignedChatModal,
  },
  data() {
    return {
      typedMessage: "",
      assignChatPopup: false,
    };
  },
  computed: {
    emojiDataAll() {
      return EmojiAllData;
    },
    emojiGroups() {
      return EmojiGroups;
    },
    ...mapState("AgentRouting", {
      assignmono: "assignmono",
    }),
    ...mapState("whatsappChat", {
      refreshPage : "refreshPage",
    }),
  },
  methods: {
    yourMethodToCatchEmojiUnicode(e) {
      this.typedMessage = e;
    },
    async sendMsg() {
      try{
        const message = this.typedMessage;
      this.$emit("sendMessage", message);
      this.$refs.emojiTextarea.cleanText();
      let payload = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload, { number: this.assignmono[0].assignedNumber });
      }

      //TO DO
      await this.$store.dispatch("whatsappChat/fetchContacts", payload);

      let payload2 = {
        refreshPage : true
      }

      await this.$store.commit("whatsappChat/REFRESH_PAGE", payload2)
      //alert(this.refreshPage)  
    }
      catch(error) {
        console.log(error, "Err");
      }
    },
  },
};
</script>
<style>
.bg-input-cl .vs-inputx {
  background: inherit !important;
}
</style>
